import { useState, ReactElement, ChangeEvent, useEffect} from 'react';
import { useCookies } from 'react-cookie';
import { Header } from '../../components/common/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAsyncEffect } from '../../helper/hooks/async-hooks';
import { joinUsers, loginUser, cancelwaitUsers } from '../../types/Reievespf001';
import { eventInfo, attachments, joinInfo } from '../../types/common';
import { getEventDetailInfo } from '../../components/event/getEventDetailInfo';
import { getEventJoinUsers } from '../../components/event/getJoinUsers';
import { getLoginName } from '../../components/event/getLoginName';
import { EventDetail } from '../../components/event/EventDetail';
import { JoinUsersList } from '../../components/event/JoinUsersList';
import { JoinRadioButton } from '../../components/event/JoinRadioButton';
import { Footer } from '../../components/common/Footer';
import { setJoin } from '../../components/event/setJoin';
import { setNotJoin } from '../../components/event/setNotJoin';
import { MailSendedModal } from '../../components/event/MailSendedModal';
import { getEventAttachments } from '../../components/event/getEventAttachments';
import { CancelWaitUsersList } from '../../components/event/CancelwaitUsersList';
import { getCancelwaitUsers } from '../../components/event/getCancelwaitUsers';
import { setCancelWaiting } from "../../components/event/setCancelWaiting";
import { getJoinStatus } from '../../components/event/getJoinStatus';

/**
 * イベント参加登録画面
 */
export function Reievespf001() {

    const navigate = useNavigate();

    //    cookieからアカウントのアドレスを取得
    const [cookieMail, setCookieMail, removeCookieMail] = useCookies(['mailCookie']);
    
    //  アカウントIDを保存するcookie
    const [cookieAccId, setCookieAccId, removeCookieAccId] = useCookies(['idCookie']);
    //  対応会員番号を保存するcookie（秘書の場合のみ）
    const [cookieSecAccId, setCookieSecAccId, removeCookieSecAccId] = useCookies(['secIdCookie'])
    //  ロータリーCDを保存するcookie
    const [cookieRotaryCd, setCookieRotaryCd, removeCookieRotaryCd] = useCookies(['rotaryCookie'])

    //  イベント詳細情報を保持するstate
    const [eventInfo, setEventInfo] = useState<eventInfo>();
    // 添付ファイル情報を保持するstate
    const [eventattachments , setEventattachments] = useState<attachments[]>([]);
    //  参加可否を保持するstate
    const [joinInfo, setJoinInfo] = useState<joinInfo>({joinFlag:null,cancel_waiting_flag:null});

    //  参加予定の会員情報を保持するstate
    const [joinUsers, setJoinUsers] = useState<joinUsers[]>([]);
    // キャンセル待ちの会員を保持するstate
    const [cancelwaitingUsers,setCancelwaiting] = useState<cancelwaitUsers[]>([]);

    //  ログイン者の氏名を保持するstate
    const [loginName, setLoginName] = useState<loginUser>();

    //  ラジオボタンの状態を保持するstate
    const [radio, setRadio] = useState<boolean>(true);

    //  モダールの表示状態を保持するstate
    const [isModal, setIsModal] = useState<boolean>(false);

    // キャンセル待ち会員の表示状態を保持するstate
    const [iscancel , setcancelModal] = useState<boolean>(false);

    const[isDetail,setIsDetail] = useState<boolean>(true);

    //  メール送信完了の状態を保持するstate
    const [isSend, setIsSend] = useState<boolean>(false);

    //  超過フラグの状態を保持するstate
    const [isMore, setIsMore] = useState<boolean>(false);

    // エラー表示を保持するstate
    const [isError, setIserror] = useState<boolean>(false);

    //  API呼び出し時のパラメータに設定するアカウントIDを保持するstate
    const [paramId, setParamId] = useState<string>("");

    // 今の時間を保持するstate
    const [limit,setLimit] = useState<boolean>(true);

    //  クエリパラメータからイベントURLを取得
    const query = new URLSearchParams(useLocation().search)
    const eventUrl = query.get('url')|| '';

    //  ログイン者のアカウントID
    const loginId = cookieAccId.idCookie

    //  初回レンダリング時、イベント詳細情報、参加予定会員情報、ログイン者の氏名を取得
    useAsyncEffect(async () => {
        if(eventUrl !== ''){
            //  イベント詳細
            const eventDetail = await getEventDetailInfo({
                eventUrl: eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            });
            setEventInfo(eventDetail);

            //  イベント詳細情報が取得できない場合、マイページに遷移
            if (Object.keys(eventDetail).length === 0) {
                navigate('/mypage')
                return;
            }

            //添付ファイルを取得する
            const eventattachments = await getEventAttachments({
                eventUrl : eventUrl,
                rotaryCd : cookieRotaryCd.rotaryCookie
            });
            setEventattachments(eventattachments)

            //  参加予定の会員
            setJoinUsers(await getEventJoinUsers({
                eventUrl: eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            }));

            //  キャンセル待ち登録の会員
            setCancelwaiting(await getCancelwaitUsers({
               eventUrl : eventUrl,
             rotaryCd : cookieRotaryCd.rotaryCookie
            }))

            let id;  
            //  対応会員番号を取得できた場合、パラメータに設定
            if(cookieSecAccId. secIdCookie != null){
                id = cookieSecAccId.secIdCookie
                setParamId(id);
            }else{
                id = cookieAccId.idCookie
                setParamId(id);
            }
            //  参加可否
            const joinStatus = await getJoinStatus({
                accountId: id,
                eventUrl: eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            })
            setJoinInfo(joinStatus);

            //  未申込でない場合、イベント詳細へ遷移
            if(Object.keys(joinStatus).length !== 0 && joinStatus.joinFlag !== null){
                navigate('/detail?url=' + eventUrl);
                return;
            }
            
            //  ログイン者の氏名（秘書の場合は対応会員の氏名）
            setLoginName(await getLoginName({
                id: id,
                rotaryCd: cookieRotaryCd.rotaryCookie
            }))
        }
    },[])

    //  モーダルの表示切替
    const changeModal = (status: boolean) => {
        setIsModal(status)
    }

    const changecancelModal = (status : boolean) => {
        setcancelModal(status)
    }

    const changeDetail = (status:boolean) =>{
        setIsDetail(status)
    }

    //  ラジオボタンの選択切替
    const changeRadio = (status: boolean) => {
        setRadio(status)
    }
    useEffect(() => {
        var check = checkLimit();
        setLimit(check);

        if(eventInfo){
            if(eventInfo.join_num >= eventInfo.limit_member){
                setLimit(true);
            }
        }

    },[eventInfo?.limit_date, eventInfo?.limit_time])

    //  登録押下時
    const registerClick = async () => {
        let res = null;
        // 期限切れしていないかの判断
        if(!checkLimit()){
            if(eventUrl){
            //  参加
                if(radio){
                    res = await setJoin({
                        loginId: loginId,
                        paramId: paramId,
                        eventUrl:eventUrl,
                        rotaryCd:cookieRotaryCd.rotaryCookie
                    });

            //  不参加
                }else if(!radio){
                    res = await setNotJoin({
                        loginId: loginId,
                        paramId: paramId,
                        eventUrl:eventUrl,
                        rotaryCd: cookieRotaryCd.rotaryCookie
                    });
                }
            }
        }

        //  メール送信まで完了したらモーダル表示
        if(res !== null && res.result === true){
            setIsSend(true)
        }else{
            //エラー表示のモーダル
            setIserror(true)
        }
    }

    //キャンセル待ち登録時

    const cancelwaitingClick = async () => {
        let res = null;
        res = await setCancelWaiting({
                        loginId: loginId,
                        paramId: paramId,
                        eventUrl:eventUrl,
                        rotaryCd:cookieRotaryCd.rotaryCookie
                    });
        if(res !== null && res.result === true){
            setIsSend(true)
        }else{
            //エラー表示のモーダル
            setIserror(true)
        }
    }



    const checkLimit = () => {
        var check = false;
            //  現在日時
            let currentDateTime = new Date();
    
            const strLimitTime = eventInfo?.limit_time;
            // var limitDate = new Date(eventInfo?.limit_date + '')

            var strLimitDate = new Date(eventInfo?.limit_date + '').toLocaleDateString();
            var limitDate = new Date(strLimitDate)
            
            if(limitDate && strLimitTime){
                //  hh:mm:ss
                const splitLimitTime = strLimitTime?.split(':')
    
                //  年月日をそれぞれ取得
                var limitHour = splitLimitTime[0]
                var limitMinute = splitLimitTime[1]
                var limitSecond = splitLimitTime[2]
    
                //  申込期限日に申込期限時刻を加算
                limitDate.setHours(limitDate.getHours() + Number(limitHour))
                limitDate.setMinutes(limitDate.getMinutes() + Number(limitMinute))
                limitDate.setSeconds(limitDate.getSeconds() + Number(limitSecond))
    
                //  現在日時と比較し、申込期限を過ぎている場合
                if(limitDate < currentDateTime){
                    check = true;
                }
            }
        return check;
    }

    return(
        <div className={`l-wrapper sp-view ${isModal == true ? "is-modal" : ""} ${isSend == true ? "is-modal" : ""}${iscancel == true ? "is-modal" : ""}`}>
            <main className="l-contents">
                <Header />

                <div className="l-default-content">
                    <div className="l-inner">
                        <div className="l-title">
                            <h2 className="title-txt">参加登録</h2>
                        </div>

                        {/* <!-- エラーメッセージエリア --> */}
                        {isError &&
                            <div className="error-message-area">
                                <div className="message-box">
                                    <ul>
                                        <li>登録ができませんでした。</li>
                                    </ul>
                                </div>
                            </div>
                        }
                        {/* <!-- /.message-area --> */}
                        <div className="l-record-wrap">
                            <EventDetail
                                detail={eventInfo ?? {
                                    subject: "",
                                    attachment_url: "",
                                    mime_type: "",
                                    icon_class: "",
                                    event_type_name: "",
                                    date: "",
                                    from_time: "",
                                    to_time: "",
                                    limit_member: 0,
                                    join_num : 0,
                                    location: "",
                                    contents : "",
                                    place:"",
                                    member_fee: 0,
                                    limit_date: "",
                                    limit_time: "",
                                    reception_time: "",
                                    phone_number: "",
                                    bank_branch : "",
                                    transfer_method : "",
                                    bank_account_address : "",
                                    bank_account_name : "",
                                    limit_bank_date : "",
                                    limit_bank_time : "",
                                    limit_date_join_num: 0,
                                    cancel_member_count: 0,
                                }}
                                isActive={isDetail}
                                setIsActive={setIsDetail}
                                attachments={eventattachments}                            
                            />
                            
                                <div className="link-box">
                                    <button 
                                        className="link-icon"
                                        onClick={() => changeModal(true)}>
                                        参加予定の会員

                                        <i className="ic-member"><img src="img/ic_member.svg" alt="" /></i>
                                    </button>
                                </div>

                                {limit &&
                                    <div className="link-box">
			        				    <button 
                                            className="link-icon"
                                            onClick={() => changecancelModal(true)}>
                                            キャンセル待ちの会員
                                    
                                            <i className="ic-member"><img src="img/ic_member_w.svg" alt=""/></i>
                                        </button>
			        			    </div>
                                }
                        </div>


                        <form>
                            <div className="event-wrap">
                                <div className="form-are">
                                    <div className="form-set">
                                        <dl>
                                            <dt className="fsz-m1 fw-b">{loginName?.name}様</dt>
                                            {/* 期限切れだったら非表示 */}
                                            {!limit &&                                              
                                                <dd className="fsz-m1 fw-b">
                                                    <fieldset className="frm-rdo-box is-unit">
                                                        <JoinRadioButton 
                                                          name={'参加'} 
                                                            radioStatus={radio} 
                                                            onChange={() => changeRadio(true)}
                                                        />
                                                        <JoinRadioButton 
                                                            name={'不参加'} 
                                                            radioStatus={radio} 
                                                            onChange={() => changeRadio(false)}
                                                        />
                                                   </fieldset>        
                                                </dd>
                                            }               
                                        </dl>
                                    </div>
                                </div>

                                {!limit ?
                                    <div className="btn-area flex-column col1">
                                        <button
                                            type="button"
                                            className="btn-main btnsz-l"
                                            onClick={() => registerClick()} >
                                            登録
                                        </button>
                                    </div>

                                :
                                
                                    <div className="btn-area flex-column col1">
					    			    <div className="record-notice">
						    			    <span className="stxt">人数超過または申し込み期限外のため参加登録ができません。<br/>キャンセル待ちに登録すると、キャンセル情報を受け取ることができます。</span>
							    	    </div>
                                        {/* キャンセル待ちを押下した時の処理 */}
				    				    
                                       <div className="btn-area flex-column col1">
                                            <button
                                                type="button"
                                                className="btn-sub btnsz-l"
                                                onClick={() => cancelwaitingClick()} >
                                                キャンセル待ち
                                            </button>
                                        </div>
							        </div>
                                }
                            </div>
                        </form>
                    </div>
                </div>

                {/**参加予定の会員　モーダル */}
                {isModal && 
                    <JoinUsersList 
                        users={joinUsers} 
                        onClick={() => changeModal(false)}
                    />
                }
                {/* キャンセル待ちの会員　モーダル */}
                {iscancel &&
                    <CancelWaitUsersList
                        users={cancelwaitingUsers}
                        onClick={() => changecancelModal(false)}
                    />
                }

                {/**メール送信完了モーダル */}
                {isSend &&
                    <MailSendedModal 
                        more_flag={isMore}
                    />
                }
            </main>
            <Footer />
        </div>
        
    );
}